import type { Clock, IdGen } from "@bundle/core";
import { monotonicFactory } from "ulid";

export const systemClock: Clock = {
  now: () => Date.now(),
  tzOffsetMinutes: (at) => -new Date(at).getTimezoneOffset(),
  setTimer: (ms, fn) => {
    const id = setTimeout(fn, ms);
    return () => clearTimeout(id);
  },
};

const ulid = monotonicFactory();
export const ulidIds: IdGen = { next: () => ulid() };
